import { MessageSort } from '@api'
import { createEvent, createStore } from 'effector'

export const setSortOption = createEvent<MessageSort>('set sort option')
export const $expiringFansMessageSortOptions = createStore<MessageSort>(
  MessageSort.DEFAULT,
).on(setSortOption, (_, sortOption) => sortOption)
